import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ILocale } from './ILocale';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LocaleLookupService {

  constructor(@Inject(HttpClient) private http: HttpClient
    , @Inject(LoggingService) private log: LoggingService
  ) { }
  uri = `${environment.apiLocation}/PerDiemLocale`;
  public get (): Observable<Array<ILocale>> {
    this.log.verbose({ type: 'LocaleLookupService:get', uri: this.uri });
    return this.http.get<Array<ILocale>>(this.uri)
      .pipe(
        tap(res => this.log.verbose({ type: 'LocaleLookupService:reponse', res }))
      )
      ;
  }

}
